import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://jveelmagtbnudwcdadpm.supabase.co';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imp2ZWVsbWFndGJudWR3Y2RhZHBtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTExMTk1MTEsImV4cCI6MjA2NjY5NTUxMX0.CymjRyzh8SoUei_1FC9q9sOXVHPihGPxrtSsnmboy2A';

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn('Supabase credentials missing. Check your .env file or build settings.');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
